// removed by extract-text-webpack-plugin
module.exports = {"inputContainer":"styles__inputContainer__3zKUR","input":"styles__input__1jocg","hasBorder":"styles__hasBorder__2H7LW","prefix":"styles__prefix__1sZ8N","suffix":"styles__suffix__21usB","simple":"styles__simple__11bdz","select":"styles__select__1weoo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Input/styles.scss
// module id = 839
// module chunks = 0